<template>
<div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>
    <loadingcomp v-bind:mesaj="''" v-model="loadingvmodel"></loadingcomp>
<v-dialog v-model="IBANDialog" persistent max-width="450"> 
<v-card>
    <v-card-title class="headline">{{ $t('IBAN-Info')}}</v-card-title>
    <v-card-text>
        <v-layout row wrap>
                              <v-flex xs12 sm12 md12>
                                <v-text-field  hide-details="" label="IBAN" v-model="guncelleIBAN.IBAN" maxlength="28">
                                </v-text-field>
                              </v-flex>
                              <v-flex xs12 sm12 md12>
                                <v-textarea  hide-details="" :label="$t('Description')" v-model="guncelleIBAN.Description">
                                </v-textarea>
                              </v-flex>
                            </v-layout>
    </v-card-text>
   
   
    <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" flat @click="IBANDialog=false">{{ $t('cancel_button')}}</v-btn>
              <v-btn color="primary" flat @click="IBANGuncelle()"
                >{{ $t('save_button')}}</v-btn
              >
            </v-card-actions>
</v-card>
</v-dialog>
    <v-card color="grey lighten-5" flat>

        <v-form>
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar style="height: 48px; align-items: baseline;" class="baslik" size="120px" dark color="info">
                        <v-toolbar-title class="baslikfont">{{$t('Edit-Current-Card')}}</v-toolbar-title>
                        <v-spacer></v-spacer>

                            <v-checkbox :label="$t('Save-in-All-Companies')" class="justify-end" v-model="tumsirketler" hide-details>
                             </v-checkbox>      
                        <v-tooltip bottom>
                            <v-btn :disabled="!sayfayetki.Update" slot="activator" @click="guncelle()" flat> <span class="hidden-sm-and-down"> 
                                {{ $t('Update') }}
                                </span>
                            </v-btn>
                            <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                        </v-tooltip>

                        <v-menu offset-y>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>
                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" :disabled="!sayfayetki.Delete" @click="carisil()">
                                        <v-list-tile-title> {{ $t('Delete') }} </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Delete"> {{ $t('Delete') }} </span>
                                </v-tooltip>

                            </v-list>
                            <v-list>
                                <a target="_self" v-bind:href="'#/cari/index/'">
                                    <v-list-tile>
                                        <v-list-tile-title>{{$t("cancel_button")}}</v-list-tile-title>
                                    </v-list-tile>
                                </a>
                            </v-list>
                        </v-menu>

                    </v-toolbar>
                </v-flex>

                <v-tabs style="width:100%; height:100%;" dark="" v-model="active" color="blue darken-3" slot="extension" slider->
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href='#0'>
                        {{$t("tab_general")}}
                    </v-tab>
                    <v-tab-item :id="'0'" style="width:100%; height:500px;">
                        <v-layout row="" wrap="">
                            <v-flex pa-1 xs12 sm6 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>
                                                <v-text-field :label="$t('Currentcode_label')" maxlength="15" v-model="Current.Code" :disabled="true" :error-messages="errors.collect('carikod')" v-validate="'required'" hide-details="" data-vv-name="carikod" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Title_label')" maxlength="100" v-model="Current.Title" :error-messages="errors.collect('unvan')" v-validate="'required'" data-vv-name="unvan" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Title_label') + ' 2'" maxlength="100" v-model="Current.Title2">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Authorized_label')" value="" v-model="Current.Authorized">
                                                </v-text-field>
                                                <v-select :items="musteritipi" hide-details="" v-model="Current.CustomerType" item-text="text" item-value="value" clearable :label="$t('Customertype_label')">
                                                </v-select>
                                                <v-text-field hide-details="" :label="$t('Phonenumber_label')" maxlength="15" v-model="Current.Phone1">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Phonenumber_label')+'2'" maxlength="15" v-model="Current.Phone2">
                                                </v-text-field>
                                                <v-text-field hide-details="" autocomplete='postal-code' :label="$t('Mobilphonenumber_label')" maxlength="15" v-model="Current.Mobile"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Email_label')" v-model="Current.Email"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Web-Address')" v-model="Current.Web"></v-text-field>
                                                 <v-flex xs12 md12 sm12>
                                                    <v-select :items="caritipi" hide-details="" v-model="Current.Buyer_Seller" item-text="text" item-value="value" clearable :label="$t('Current-Type')">
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                            <v-layout row wrap>

                                <v-flex pa-1 xs12 sm6 md12>
                                    <v-card class="white--text">
                                        <v-card flat="">
                                            <v-card-actions>
                                                <v-layout justify-space-between column>
                                                    <v-textarea v-model="Current.InfoNote" :label="$t('Infonote_label')"></v-textarea>
                                                    <v-textarea v-model="Current.WarningNote" :label="$t('Warningnote_label')"></v-textarea>
                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>

                                    <v-card class="white--text mt-2">
                                        <v-card flat="">
                                            <v-card-actions>
                                                <v-layout row wrap>
                                                    <v-flex xs12 pb-1 sm12 md4>
                                                        <v-switch v-if="Current.InActive" :label="$t('Open-this-current')" v-model="Current.InActive"  @change="ActiveCurrent()" hide-details="">
                                                        </v-switch>
                                                        <v-switch v-if="!Current.InActive" :label="$t('Deactivate-this-current')" v-model="Current.InActive" @change="ActiveCurrent()" hide-details="">
                                                        </v-switch>
                                                    </v-flex>
                                                    <v-layout align-end>
                                                        <v-flex v-if="Current.InActive" xs12 sm12 md4>
                                                            <v-list>
                                                                <v-list-tile-content>
                                                                    <v-list-tile-title>{{ $t('Current-De-activation-Date') }} :</v-list-tile-title>
                                                                    <v-list-tile-sub-title>{{ Current.InActiveDate | dateformat}}</v-list-tile-sub-title>
                                                                </v-list-tile-content>
                                                            </v-list>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-card>
                                </v-flex>
                            </v-layout>

                        </v-layout>

                    </v-tab-item>
                    <v-tab href='#1' ripple>
                        {{ $t('tab_invoiceinformation') }}
                    </v-tab>
                    <v-tab-item :id="'1'" style="width:100%; height:100%;">
                        <v-layout row="" wrap="">
                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                   {{ $t('Billingaddressinformation_headers')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>
                                                <v-text-field hide-details="" :label="$t('Taxcenter_label')" v-model="Current.Invoice.TaxOffice">
                                                </v-text-field>
                                                <v-layout align="center">
                                                    <v-flex xs8 sm8 md8>
                                                        <v-form ref="vergino" v-model="valid" lazy-validation>
                                                            <v-text-field hide-details="" mask="###############"  :label="$t('Taxnumber_label')" v-model="Current.Invoice.TaxNumber"></v-text-field>
                                                        </v-form>
                                                    </v-flex>
                                                    <v-flex xs4 sm4 md4 v-if="PB=='TRY'">
                                                        <v-layout align="center" fill-height column justify-end>

                                                            <v-btn v-if="!mukellefScroll" small flat @click="mukellefSorgula()" color="info">
                                                               {{ $t('Inquire-Liables') }} <v-icon>search</v-icon>
                                                            </v-btn>

                                                            <v-progress-linear v-if="mukellefScroll" color="red" indeterminate rounded height="6">
                                                            </v-progress-linear>
                                                        </v-layout>
                                                    </v-flex>

                                                </v-layout>
                                                <v-text-field hide-details="" :label="$t('Postcode_label')" v-model="Current.Invoice.PostCode">
                                                </v-text-field>
                                                <v-combobox
          v-model="Current.Invoice.Country"
          :items="ulkeTipi"
          :label="$t('Country_label')"
        ></v-combobox>
                                                <!-- <v-text-field hide-details="" :label="$t('Country_label')" v-model="Current.Invoice.Country"></v-text-field> -->
                                                <v-text-field hide-details="" :label="$t('Province_label')" v-model="Current.Invoice.Province">
                                                   
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('BuildingNumber')" v-model="Current.Invoice.BuildingNumber" maxlength="5">  </v-text-field>
                                                <v-textarea hide-details="" no-resize v-model="Current.Invoice.Address" :label="$t('Address_label')">
                                                </v-textarea v-if="PB=='TRY'">
                                                 <v-text-field hide-details="" :label="$t('Expense-Unit-VKN')" mask="##########" v-model="Current.Invoice.SpendingUnitVKN">
                                                </v-text-field>
                                                <v-checkbox :label="$t('Dontbebilled_label')" v-model="biletlerfaturalanmasin" hide-details>
                                                </v-checkbox>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>

                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pb-2 pt-1 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Foridentity_header') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Identitynumber_label')" value="" mask="###########" v-model="Current.Invoice.IdentityNumber"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Name_label')" maxlength="50" v-model="Current.Invoice.PerFirstName" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Surname_label')" maxlength="50" v-model="Current.Invoice.PerFamilyName" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Title_label')" maxlength="50" v-model="Current.Invoice.PerTitle" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Othername_label')" maxlength="50" v-model="Current.Invoice.PerMiddleName" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Suffixname_label')" maxlength="50" v-model="Current.Invoice.PerNameSuffix" required>
                                                </v-text-field>
                                                <v-text-field hide-details="" label="Passport Number" maxlength="9" v-model="Current.Invoice.PassportNumber" required>
                                                </v-text-field>
                                                
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text" v-if="PB=='TRY'">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pb-2 pt-1 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('E-invoiceamenable_header') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-select hide-details="" :items="efaturatipi" v-model="Current.EInvoiceType" item-text="text" item-value="value" :label="$t('E-invoicetype')"></v-select>

                                                <v-text-field v-if="cokluposta==false" hide-details="" :label="$t('Post-Label')" v-model="Current.PostCodeLabel">
                                                </v-text-field>

                                                <v-select v-if="cokluposta==true" :items="postaitems" hide-details="" v-model="Current.PostCodeLabel" clearable :label="$t('Post-Label')">
                                                </v-select>

                                                <v-checkbox :label="$t('E-invoicetypeamenable_label')" v-model="efaturamukellefi" hide-details></v-checkbox>
                                                <v-checkbox :label="$t('Usingmultiplemail_label')" v-model="Current.MultiPostUse" hide-details>
                                                </v-checkbox>

                                                <v-flex xs12 sm12 pb-2 pt-4 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{$t('E-archiveinfo_header')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-select hide-details="" :items="islembilgileri" v-model="Current.EArchiveSendType" item-text="text" item-value="value" :label="$t('E-archiveprocessinformationtype_label')"></v-select>
                                                <v-checkbox :label="$t('Printonpaperinsteadofe-archive')" v-model="Current.EArchiveSendPaper" hide-details></v-checkbox>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#2' ripple>
                        {{ $t('Contract') }}
                    </v-tab>
                    <v-tab-item :id="'2'">
                        <v-layout row="" wrap="">

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                   {{$t('Definitions-v2')}}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Contract-No')" v-model="Current.Contract.ContractNumber" required>
                                                </v-text-field>
                                                <tarihim :etiket="$t('Contract-Commencement')" :detaygizle="true" v-model="date" v-bind:value="date" v-bind:defaultvalue="'no'"></tarihim>

                                                <parainput v-model="Current.CreditLimit" :simge="getparabirimi()" :etiket="$t('Credit-Limit')" :autocomplete="'autocomplete'"></parainput>

                                                <v-text-field hide-details="" :label="$t('Currency')" v-model="Current.CreditLimitCurrencyAmount">
                                                </v-text-field>
                                                <v-select hide-details="" :items="doviztipi" clearable item-text="DovizAdi" item-value="DovizKod" v-model="Current.CreditLimitCurrency" :label="$t('Currency-Unit')"></v-select>
                                                <v-text-field hide-details="" :label="$t('Payment-Method')" v-model="Current.Contract.PaymentType">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Bank-Account-No')" v-model="Current.Contract.BankAccountNumber"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Bank-Branch-Code')" v-model="Current.Contract.BankBranchOffice"></v-text-field>
                                                <v-text-field hide-details="" label="DOT9 Şifre" v-model="Current.WebPassword"></v-text-field>
                                                <v-text-field hide-details="" autocomplete='postal-code' :label="$t('Pin-Code')" v-model="Current.PinCode"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('MIL-Code')" v-model="Current.MileCode"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Bank')" v-model="Current.Bank"></v-text-field>

                                            </v-layout>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Terms') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="info" @click.native="dialogfiltre=true" flat><span class="caption info--text font-weight-medium ">
                                                                {{ $t('Type-Explanations') }}
                                                            </span> &nbsp;<v-icon small color="info">help_outline</v-icon>
                                                            </v-btn>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field hide-details="" type="Number" :label="$t('Domestic-Line')" v-model="Current.ExpiryDayDomestic"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="vadetipi" hide-details="" item-text="value" item-value="value" clearable v-model="Current.ExpiryTypeDomestic"  :label="this.$t('Type')"></v-select>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field hide-details="" type="Number" :label="$t('International-Line')" v-model="Current.ExpiryDayInt"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="vadetipi" hide-details="" item-text="value" item-value="value"  :label="this.$t('Type')" v-model="Current.ExpiryTypeInt" clearable></v-select>
                                                    </v-flex>
                                                </v-layout>
                                                <v-layout>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-text-field hide-details="" :label="$t('tab_general')" type="Number" v-model="Current.ExpiryDayGeneral"></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs12 sm6 md6>
                                                        <v-select :items="vadetipi" item-text="value" item-value="value" hide-details=""  :label="this.$t('Type')" v-model="Current.ExpiryTypeGeneral" clearable></v-select>
                                                    </v-flex>
                                                </v-layout>

                                                <v-flex xs12 pb-2 sm12 pt-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Discounts') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" :label="$t('Domestic-Line')" v-model="Current.DiscountDom"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('International-Line')" v-model="Current.DiscountInt"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Domestic-Service')" v-model="Current.DiscountDomService">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('International-Service')" v-model="Current.DiscountIntService">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('tab_general')" v-model="Current.DiscountGeneral"></v-text-field>

                                            </v-layout>

                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm6 md4>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>

                                            <v-layout justify-space-between column>

                                                <v-flex xs12 pb-2 sm12 pt-1 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Invoice-Articles') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-text-field hide-details="" type="Number" :label="$t('Number-of-Rows-in-Invoice')" value="" v-model="Current.Contract.InvoiceRowNumber"></v-text-field>
                                                <v-select :items="evethayir" hide-details="" clearable item-text="text" item-value="value" v-model="Current.Contract.InvoicePassengerName" :label="$t('Invoice-Passenger-Name')"></v-select>
                                                <v-select hide-details="" :items="evethayir" clearable item-text="text" item-value="value" v-model="Current.Contract.InvoiceFlightNumber" :label="$t('Invoice-Flight-No')"></v-select>
                                                <v-checkbox :label="$t('VAT-Exemption')" v-model="Kdvmuaf" hide-details></v-checkbox>
                                                <v-checkbox v-if="PB=='TRY'" :label="$t('Do-not-want-paper-print')" v-model="ciktiistemiyor" hide-details></v-checkbox>
                                                <v-checkbox v-if="PB=='TRY'" :label="$t('Show-client-personal-information-invoice')" v-model="musteribilgitipi" hide-details></v-checkbox>
                                                <v-checkbox v-if="PB=='TRY'" :label="$t('Tevkifatlı')" v-model="Current.Contract.Tevkifatli" hide-details>
                                                </v-checkbox>
                                                <v-text-field v-if="PB=='TRY' && Current.Contract.Tevkifatli" v-model="Current.Contract.TevkifatKodu" label="Tevkifat kodu" hide-details />
                                                <v-select v-if="PB=='TRY' && Current.Contract.Tevkifatli" :items="tevkifatOranlari" v-model="Current.Contract.TevkifatOrani" item-text="text" item-value="value" label="Tevkifat oranı" hide-details clearable :rules="[v => !Current.Contract.Tevkifatli || (v !== null && v !== '') || 'Tevkifat oranı zorunlu']" :required="Current.Contract.Tevkifatli"></v-select>
                                                <v-checkbox :label="$t('İade Cari Ayrılsın')" v-model="Current.Contract.IadeCariAyrilsin" hide-details></v-checkbox>
                                                <cariaracomp v-if="Current.Contract.IadeCariAyrilsin" :etiket="$t('İade Cari')" :loading="loading" v-bind:value="Current.Contract.IadeCariKod" v-model="Current.Contract.IadeCariKod"></cariaracomp>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                        </v-layout>
                    </v-tab-item>
                    <v-tab href='#3' ripple>
                        {{$t('Service-Fee')}}
                    </v-tab>
                    <v-tab-item :id="'3'">

                        <v-layout row="" wrap>
                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row="" wrap justify-start="" fill-height="">

                                                <v-flex xs12 sm12 pb-2 pt-1 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('Domestic-Line-Service-Fees') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>

                                                <v-flex xs12 sm8 md8>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text">11-</span>
                                                                        </v-chip>
                                                                        <v-checkbox v-model="ServisParametre.DefaultServis11" @change="DefaultIcAyarlar(ServisParametre.DefaultServis11,'11')"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput v-model="ServisParametre.Fiyat11" :simge="getparabirimi()" :id="'Fiyat11'" :etiket="$t('Domestic-Low-Cost')" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete id="doviz11" v-model="ServisParametre.Doviztip11" hide-details="" :disabled="false" :items="doviztipi" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text"> 12- </span>
                                                                        </v-chip>
                                                                        <v-checkbox v-model="ServisParametre.DefaultServis12" @change="DefaultIcAyarlar(ServisParametre.DefaultServis12,'12')"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="'İç Eco Cost Fiyat'" :simge="getparabirimi()" v-model="ServisParametre.Fiyat12" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" v-model="ServisParametre.Doviztip12" :disabled="false" :items="doviztipi" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text"> 13-</span>
                                                                        </v-chip>
                                                                        <v-checkbox v-model="ServisParametre.DefaultServis13" @change="DefaultIcAyarlar(ServisParametre.DefaultServis13,'13')"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="$t('Business-Cost-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat13" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :disabled="false" :items="doviztipi" v-model="ServisParametre.Doviztip13" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text"> 15- </span>
                                                                        </v-chip>
                                                                        <v-checkbox v-model="ServisParametre.DefaultServis15" @change="DefaultIcAyarlar(ServisParametre.DefaultServis15,'15')"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :etiket="$t('Return-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat15" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :disabled="false" :items="doviztipi" v-model="ServisParametre.Doviztip15" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="red" label>
                                                                            <span class="white--text caption"> 19-</span>
                                                                        </v-chip>
                                                                        <v-checkbox v-model="ServisParametre.DefaultServis19" @change="DefaultIcAyarlar(ServisParametre.DefaultServis19,'19')"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm4 md4>
                                                                    <parainput :simge="getparabirimi()" :etiket="$t('Internal-Reservation-Change-Fee')" v-model="ServisParametre.Fiyat19" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :disabled="false" :items="doviztipi" v-model="ServisParametre.Doviztip19" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm4 md4>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-checkbox v-model="icYuzdedenHesapla.Yuzdeden" :label="$t('Domestic-Lines-Calculation')" hide-details>
                                                            </v-checkbox>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-select hide-details="" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapTipi" :items="hesaptipi" item-text="text" item-value="value" :label="$t('Account-Type')"></v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <yuzdeinput :etiket="$t('Percentage') + '%'" v-if="icyuzde" v-model="icYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row="" wrap justify-start="" fill-height="">
                                                <v-flex xs12 sm12 pt-1 pb-2 md12>
                                                    <v-layout row wrap class=" project overdue">
                                                        <v-toolbar flat="" size="100px" dark color="white">
                                                            <v-toolbar-title>
                                                                <span class="title black--text font-weight-">
                                                                    {{ $t('International-Lines-Service-Prices') }}
                                                                </span>
                                                            </v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                        </v-toolbar>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm6 md8>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 21-</span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis21,'21')" v-model="ServisParametre.DefaultServis21"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>

                                                                    <parainput :etiket="$t('International-Short-Cost-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat21" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip21" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 22- </span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis22,'22')" v-model="ServisParametre.DefaultServis22"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Short-Business-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat22" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm2 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip22" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 31-</span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis31,'31')" v-model="ServisParametre.DefaultServis31"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Long-Eco-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat31" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip31" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text"> 32-</span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis32,'32')" v-model="ServisParametre.DefaultServis32"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Long-Business-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat32" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip32" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm12 md12>

                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text caption"> 33-</span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis33,'33')" v-model="ServisParametre.DefaultServis33"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('First-Class-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat33" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip33" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text caption"> 40-</span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis40,'40')" v-model="ServisParametre.DefaultServis40"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Return-Price')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat40" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip40" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')">
                                                                    </v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout>
                                                                <v-flex xs12 sm2 md2>
                                                                    <v-layout align-center fill-height="">
                                                                        <v-chip color="info" label>
                                                                            <span class="white--text caption"> 44-</span>
                                                                        </v-chip>
                                                                        <v-checkbox @change="DefaultDisAyarlar(ServisParametre.DefaultServis44,'44')" v-model="ServisParametre.DefaultServis44"></v-checkbox>
                                                                    </v-layout>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <parainput :etiket="$t('International-Reservation-Change-Fee')" :simge="getparabirimi()" v-model="ServisParametre.Fiyat44" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <v-flex xs12 sm5 md5>
                                                                    <v-autocomplete hide-details="" :items="doviztipi" v-model="ServisParametre.Doviztip44" clearable item-text="DovizUnvan" item-value="DovizKod" :label="$t('Currency-Type')"></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                                <v-flex xs12 sm4 md4>
                                                    <v-layout align-content-start="" fill-height="" row wrap>
                                                        <v-flex xs12 sm6 md12>
                                                            <v-checkbox v-model="DisYuzdedenHesapla.Yuzdeden" :label="$t('International-Line-Calculation')" hide-details></v-checkbox>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md12>
                                                            <v-select hide-details="" v-model="DisYuzdedenHesapla.HesapTipi" :items="hesaptipi" clearable item-text="text" v-if="disyuzde" item-value="value" :label="$t('Account-Type')">
                                                            </v-select>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md12>
                                                            <yuzdeinput :etiket="$t('Percentage') + '%'" v-if="disyuzde" v-model="DisYuzdedenHesapla.HesapYuzde" :autocomplete="'autocomplete'"></yuzdeinput>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                            <v-layout align-content-start="" justify-end="" fill-height="" row wrap>
                                <v-flex pa-1 xs12 sm2 md2>
                                    <v-btn @click="servissil()" block color="info">
                                        {{ $t('Delete-Service-Details') }}
                                    </v-btn>
                                </v-flex>
                                <v-flex pa-1 xs12 sm2 md2>
                                    <v-btn @click="serviskaydet()" block="" color="info">
                                        {{ $t('Update-Service-Details') }}
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#4' @click.native="cariStatus = true" ripple>
                        {{ $t('Other') }}
                    </v-tab>
                    <v-tab-item :id="'4'">
                        <v-layout row="" wrap="">
                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>
                                                <muhasebekoducomp v-if="PB=='TRY'"  :etiket="$t('Accounting-Code')"  v-model="Current.AccountingCode" maxlength="25" :readonly="accounting" :hint="$t('Arama Butonu ile Seçim Yapabilirsiniz')" ></muhasebekoducomp>
                                                <v-text-field hide-details="" :label="$t('Export-current-code')" v-model="Current.ExternalCurrentCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Data-Export-Current-Code')" v-model="Current.ExternalAccountingCode"> 
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Transfer-Current-Code')" v-model="Current.StreamCurrentCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Arkman-Transfer-Code')" v-model="Current.ArkmanStreamCode">
                                                </v-text-field>
                                                <v-text-field hide-details="" :label="$t('Arkman-Transfer-Password')" v-model="Current.ArkmanStreamPassword">
                                                </v-text-field>
                                                <v-text-field hide-details="" name="input-3-3" v-model="Current.Invoice.DeliveryAddress" :label="$t('Delivery-Address')"></v-text-field>
                                                <v-text-field hide-details="" :label="$t('Name-Delivery')" v-model="Current.Invoice.DeliveryName">
                                                </v-text-field>
                                                <v-autocomplete :items="masrafmerkezi" hide-details="" clearable item-text="Title" item-value="Code" v-model="Current.ExpenseCenter" class="text-xs" :label="this.$t('Expense-Center')">
                                                </v-autocomplete>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>

                            <v-flex pa-1 xs12 sm12 md6>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout justify-space-between column>
                                                <v-select hide-details="" clearable v-model="Current.TemplateID" :label="$t('Template-Selection-Profile')">
                                                </v-select>
               
                                                 <cariaracomp v-bind:etiket="$t('Main-Account')" v-if='cariStatus'  :loading="loading" v-bind:value="Current.MainAccount" v-model="Current.MainAccount"></cariaracomp>

                                                <v-autocomplete hide-details clearable :items="hesapgurubu" v-model="Current.AccountGroup" :label="$t('Account-Group')" item-text="Title" item-value="Kod" max-height="400">
                                                </v-autocomplete>

                                                <v-select v-if="PB=='TRY'" hide-details="" clearable :label="$t('CM-Code')" :items="cmkodu" v-model="Current.CMCode">
                                                </v-select>

                                                <analizcomp :etiket="$t('Analysis-Code')" v-model="Current.AnalysisCode"></analizcomp>

                                                     <v-layout justify-space-between row>

                                                <v-flex xs12 sm6 md6 v-if="PB=='TRY'">
                                                
                                                 <v-text-field  hide-details="" :label="$t('Special-Code') + ' 5'" v-model="Current.PrivateCode5">
                                                </v-text-field>
                                                
                                                <v-text-field hide-details="" :label="$t('Special-Code') + ' 6'" v-model="Current.PrivateCode6">
                                                </v-text-field>
                                                
                                                <v-checkbox :label="$t('Periodic-Code')" v-model="Current.PeriodControl" hide-details></v-checkbox>

                                                </v-flex>
                                               <v-flex xs12 sm6 md6 v-if="PB=='TRY'">
                                                
                                                <v-text-field hide-details="" :label="$t('Special-Code') + ' 7'" v-model="Current.PrivateCode7">
                                                </v-text-field>
                                                
                                                <v-text-field hide-details="" :label="$t('Special-Code') + ' 8'" v-model="Current.PrivateCode8">
                                                </v-text-field>  

                                                 <v-checkbox :label="$t('Profile-Mandatory')" v-model="profilzorunlu" hide-details></v-checkbox>
                                                <v-checkbox :label="$t('EventID-Mandatory')" v-model="eventidzorunlu" hide-details></v-checkbox>
                                                </v-flex>
                                                 </v-layout>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#5' ripple>
                        {{$t('Notes')}}
                    </v-tab>
                    <v-tab-item :id="'5'">
                        <v-flex pa-1 xs12 sm12 md12>
                            <v-card class="white--text">
                                <v-card flat="">
                                    <v-card-actions>

                                        <v-layout row="" wrap="">
                                            <v-flex xs12 sm12 md12>

                                                <v-layout justify-space-between column>
                                                    <v-textarea hide-details="" v-model="Current.Explanations" :label="$t('Notes')"></v-textarea>
                                                </v-layout>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-actions>
                                </v-card>
                            </v-card>
                        </v-flex>
                    </v-tab-item>
                    <v-tab href='#6' ripple>
                        {{ $t('Airline-Users') }}
                    </v-tab>
                    <v-tab-item :id="'6'">
                        <v-form ref="formtarih" v-model="valid" lazy-validation>

                            <v-flex pa-1 xs12 sm12 md12>
                                <v-card class="white--text">
                                    <v-card flat="">
                                        <v-card-actions>
                                            <v-layout row="" wrap="">

                                                <v-flex xs12 pt-2 pb-2 sm12 md12>
                                                    <v-card flat>
                                                        <v-layout pa-2 row="" wrap="">
                                                            <v-flex xs12 sm12 md12>
                                                                <span class=" font-weight-regular grey--text subheading"> {{ $t('New-Transfer-Code') }} </span>
                                                                <v-divider></v-divider>
                                                            </v-flex>

                                                            <v-flex xs12 sm12 md3>
                                                                <v-autocomplete clearable :items="itemsairlinelist" :label="$t('Select-Airline')" item-text="Title" :rules="[v => !!v || $t('Please-Choose-Airline')]" v-model="havayolukodu" item-value="HavaYoluKodu">

                                                                </v-autocomplete>
                                                            </v-flex>
                                                            <v-flex xs12 sm13 md3>
                                                                <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="aktarimKodu" :label="havayoluLabel"></v-text-field>
                                                            </v-flex>

                                                            <v-flex xs12 sm4 md1>
                                                                <v-layout align-center fill-height>
                                                                    <v-btn v-show="!guncellbtn" color="info" @click="aktarimkoduEkle()">
                                                                      {{this.$t('Add-New-Transfer-Code')}}</v-btn>
                                                                    <v-btn v-show="guncellbtn" color="info" @click="aktarimGuncelle()">{{ $t('Update') }}</v-btn>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs12 sm4 md1>
                                                                <v-layout align-center fill-height>
                                                                    <v-btn v-show="guncellbtn" color="info" @click="islemiptal()">{{$t("cancel_button")}}</v-btn>
                                                                </v-layout>
                                                            </v-flex>

                                                        </v-layout>
                                                    </v-card>
                                                </v-flex>

                                                <v-flex xs12 pt-2 pb-2 sm12 md12>
                                                    <v-card flat>
                                                        <v-layout pa-2 row="" wrap="">
                                                            <v-flex xs12 pt-2 pb-2 sm12 md12>
                                                                <span class=" font-weight-regular grey--text subheading">
                                                                    {{ $t('Airline-Transfer-Code-List') }}
                                                                </span>
                                                                <v-divider></v-divider>
                                                            </v-flex>

                                                            <v-flex xs12 sm12 md12>
                                                                <v-card flat>
                                                                    <v-data-table :headers="headeraktarim" :items="aktarimitems" hide-actions class="elevation-1">
                                                                        <template slot="items" slot-scope="props">
                                                                            <tr item>
                                                                                <td class="text-xs-left">{{ props.item.CariKodu}}</td>
                                                                                <td class="text-xs-left">{{ props.item.HavayoluKodu}}</td>
                                                                                <td class="text-xs-left">{{ props.item.AktarimKodu }}</td>
                                                                                <td class="text-xs-right">
                                                                                    <v-btn icon>
                                                                                        <v-icon @click="satirduzenle(props.item)" color="teal">edit</v-icon>
                                                                                    </v-btn>
                                                                                    <v-btn @click="satirsilsor(props.item)" icon>
                                                                                        <v-icon color="red">delete</v-icon>
                                                                                    </v-btn>
                                                                                </td>

                                                                            </tr>
                                                                        </template>
                                                                    </v-data-table>
                                                                </v-card>

                                                            </v-flex>

                                                        </v-layout>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-actions>
                                    </v-card>
                                </v-card>
                            </v-flex>
                        </v-form>
                    </v-tab-item>
                    <v-tab href='#7' @click="sablonGetir()" ripple>
                       {{$t('Templates')}}
                    </v-tab>
                    <v-tab-item :id="'7'">
                       <v-flex pa-2 xs12 sm12 md12>
                           <v-layout row wrap>
                           <v-flex xs12 sm6 md6 pr-2>
                               <v-card>
                                   <v-card-title primary-title>
                                    {{$t('Templates')}}
                                   </v-card-title>
                                   <v-card-text v-if="itemsSablon.length > 0">
                                    <v-layout row wrap align-center justify-center v-for="item in itemsSablon" :key="item.id">
                                      
                                       <v-flex xs11 sm11 md11>
                                           {{item.ad}}
                                       </v-flex>
                                          <v-flex xs2 sm2 md1>
                                        <v-btn icon ripple>
                                            <v-icon @click="ItemAktar(item,1)" color="green">
                                            arrow_forward_ios
                                            </v-icon>
                                        </v-btn>
                                       </v-flex>
                                    
                                      </v-layout>
                                   </v-card-text>
                               </v-card>
                           </v-flex>
                            <v-flex xs12 sm6 md6 pl-2>
                                 <v-card>
                                   <v-card-title primary-title>
                                    {{$t('Selected-Templates')}}
                                   </v-card-title>
                                     <v-card-text v-if="itemsSablonSelected.length > 0">
                                        <v-layout row wrap align-center justify-center v-for="item in itemsSablonSelected" :key="item.id">
                                         <v-flex xs2 sm2 md1>
                                        <v-btn icon ripple>
                                            <v-icon @click="ItemAktar(item,2)" color="red">
                                            arrow_back_ios
                                            </v-icon>
                                        </v-btn>
                                       </v-flex>
                                       <v-flex xs11 sm11 md11>
                                           {{item.ad}}
                                       </v-flex>
                                    
                                      </v-layout>
                                   </v-card-text>
                               </v-card>
                           </v-flex>
                           </v-layout>
                         
                                
                        </v-flex>
                    </v-tab-item> 
                    <v-tab href='#8'  ripple>
                       {{$t('Bank-Info')}}
                    </v-tab>
                    <v-tab-item :id="'8'">
                        <v-form ref="formbanka" v-model="validbanka" lazy-validation>

<v-flex pa-1 xs12 sm12 md12>
    <v-card class="white--text">
        <v-card flat="">
            <v-card-actions>
                <v-layout row="" wrap="">

                    <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-card flat>
                            <v-layout pa-2 row="" wrap="">
                                <v-flex xs12 sm12 md12>
                                    <span class=" font-weight-regular grey--text subheading"> {{ $t('IBAN') }} </span>
                                    <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md3>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IBANAd" label="IBAN" maxlength="28"></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm13 md3>
                                    <v-text-field :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IBANDesc" :label="this.$t('Description')"></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm4 md1>
                                    <v-layout align-center fill-height>
                                        <v-btn  color="info" @click="IBANEkle()">
                                          {{this.$t('Add-IBAN')}}</v-btn>
                                       
                                    </v-layout>
                                </v-flex>
                             

                            </v-layout>
                        </v-card>
                    </v-flex>

                    <v-flex xs12 pt-2 pb-2 sm12 md12>
                        <v-card flat>
                            <v-layout pa-2 row="" wrap="">
                                <v-flex xs12 pt-2 pb-2 sm12 md12>
                                    <span class=" font-weight-regular grey--text subheading">
                                        {{ $t('IBAN-LIST') }}
                                    </span>
                                    <v-divider></v-divider>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-card flat>
                                        <v-data-table :headers="headersbankinfo" :items="Current.BankInfo" hide-actions class="elevation-1">
                                            <template slot="items" slot-scope="props">
                                                <tr item v-if="props.item.Silinecek==false">
                                                    <td class="text-xs-left">{{ props.item.IBAN}}</td>
                                                    <td class="text-xs-left">{{ props.item.Description}}</td>
                                                    <td class="text-xs-right">
                                                        <v-btn icon>
                                                            <v-icon @click="IBANGuncelleAc(props.item)" color="teal">edit</v-icon>
                                                        </v-btn>
                                                        <v-btn @click="IBANSilSor(props.item)" icon>
                                                            <v-icon color="red">delete</v-icon>
                                                        </v-btn>
                                                    </td>

                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-card>

                                </v-flex>

                            </v-layout>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-card-actions>
        </v-card>
    </v-card>
</v-flex>
</v-form>
                    </v-tab-item> 
                </v-tabs>

                <v-dialog v-model="dialogfiltre" scrollable="" max-width="500px">
                    <v-card flat color="grey lighten-5">

                        <v-card-title>{{ $t('Term-Type-Explanations') }}</v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>

                            <v-flex xs12 sm12 md12>
                                <v-list two-line>
                                    <template v-for="(item, index) in vadetipi">
                                        <v-subheader v-if="item.header" :key="item.header">

                                        </v-subheader>

                                        <v-divider v-else-if="item.divider" :key="index" :inset="item.inset"></v-divider>

                                        <v-list-tile v-else :key="item.title">
                                            <v-list-tile-avatar>
                                                {{item.value}}
                                            </v-list-tile-avatar>

                                            <v-list-tile-content>
                                                <span class="caption"> {{item.text}}</span>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                    </template>
                                </v-list>

                            </v-flex>

                        </v-card-text>

                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" flat @click.native="dialogfiltre=false">{{$t('Close')}}</v-btn>

                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogyetki" persistent width="500">
                    <v-card color="primary" dark>
                        <v-card-text>
                            <v-layout align-center="" align-start row wrap fill-height="">
                                <v-flex pa-2 xs1 sm1 md1>
                                    <v-icon large color="white">fingerprint</v-icon>
                                </v-flex>
                                <v-flex pa-3 xs11 sm11 md11>
                                    <span class="subheading">
                                         {{ $t('have-authority-view-page-request-authority-manager') }} 
                                    </span>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="white" flat @click="logout()"> {{ $t('Previous-Page') }} </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>

                <v-dialog v-model="dialogsor" persistent max-width="290">
                    <v-card>
                        <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                        <v-card-text> {{ $t('Are-you-sure-want-delete') }} </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="info" flat @click.native="dialogsor=false">{{$t("cancel_button")}}</v-btn>

                            <v-btn v-if="satirsilbtn" color="info" flat @click="satirsil()">{{ $t('OK') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogsorIBAN" persistent max-width="290">
                    <v-card>
                        <v-card-title class="headline">{{ $t('Warning') }} !</v-card-title>
                        <v-card-text> {{ $t('Are-you-sure-want-delete') }} </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="info" flat @click.native="dialogsorIBAN=false">{{$t("cancel_button")}}</v-btn>

                            <v-btn color="info" flat @click="IBANSil()">{{ $t('OK') }}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-layout>
        </v-form>
    </v-card>
</div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import tarihim from "@/components/app/customcomp/tarihim.vue"
import yuzdeinput from "@/components/app/customcomp/yuzdeinput.vue"
import tool from "../coper/tools";
import helpers from "@/components/app/customcomp/helpers.js"
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
import cariaracomp from '@/components/app/customcomp/cariaracomp'
import analizcomp from '@/components/app/bilet/partpage/analizcomp'
import muhasebekoducomp from '@/components/app/customcomp/muhasebekoducomp'
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp"


export default {

    props: {
        operation: ''
    },

    data() {
        return {
            ulkeTipi:[],
            Tevkifatli: false,
            TevkifatKodu: null,
        tevkifatOranlari: Array.from({ length: 11 }, (_, i) => ({
        text: `${i}/10`,
        value: i / 10, 
      })),
            accounting:false,
            guncelleIBAN:{
IBAN:'',
Description:'',
Silinecek:false
            },
            IBANAdGuncelle:'',
            IBANDescGuncelle:'',
            IBANDialog:false,
            IBANAd:'',
            IBANDesc:'',
            PB:"TRY",
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },
            tumsirketler:false,
            cariStatus:false,
            prevRoute: null,
            dialogyetki: false,
            guncellbtn: false,
            satirsilbtn: true,
            silinecekkayit: null,
            dialogsor: false,
            dialogsorIBAN:false,
headersbankinfo:[
{
     text: this.$t('IBAN'),
                    value: 'IBAN'
},
{
                    text: this.$t('Description'),
                    value: 'Description'
                },
],
            headeraktarim: [{
                    text: this.$t('Currentcode_label'),
                    value: 'CariKodu'
                },
                {
                    text: this.$t('Airline-Code'),
                    value: 'HavayoluKodu'
                },
                {
                    text: this.$t('Transfer-Code-v2'),
                    value: 'AktarimKodu'
                },
                {
                    text: this.$t('Process'),
                    value: '',
                    align: 'right'
                },
            ],
            aktarimitems: [],
            
            aktarimKodu: null,
            havayoluLabel:this.$t('Transfer-Code-v2'),
            havayolukodu: null,
            itemsairlinelist: [{
                Title: 'H9 - PEGASUS',
                HavaYoluKodu: 'H9'
            }],
            hesapgurubu: [],
            dialogfiltre: false,
            vadetipi: [{
                    value: 'D',
                    text: this.$t('transfer-date-lesser-than-transfer-date-day')
                },
                {
                    value: 'D+',
                    text: this.$t('transfer-date-lesser-transfer-date-greater-day')
                },
                {
                    value: 'D-',
                    text: this.$t('transfer-date-lesser-transfer-date-greater-day')
                },
                {
                    value: 'E',
                    text: this.$t('transfer-date-lesser-day-next-month-greater')
                },
                {
                    value: 'E+',
                    text: this.$t('day-the-first-month-number-entered-days')
                },
                {
                    value: 'E-',
                    text: this.$t('first-month-number-entered-days')
                },

                {
                    value: 'K',
                    text: this.$t('day-first-month')
                },
                {
                    value: 'K+',
                    text: this.$t('month-number-entered-days')
                },
                {
                    value: 'K-',
                    text: this.$t('month-number-entered-days')
                },
                {
                    value: 'L',
                    text: this.$t('day-first-month-twenty')
                }, {
                    value: 'L-',
                    text: this.$t('the-first-month-number-entered-days')
                }, {
                    value: 'L+',
                    text: this.$t('first-month-number-entered-days-v2')
                }, {
                    value: 'M',
                    text: this.$t('day-of-the-first-month')
                }, {
                    value: 'M+',
                    text: this.$t('first-month-number-entered-days-v3')
                }, {
                    value: 'M-',
                    text: this.$t('first-month-number-entered-days-v4')
                },
                {
                    value: 'R',
                    text: this.$t('day-of-if-the-transfer')
                },
                {
                    value: 'R+',
                    text: this.$t('entered-days-date-lesser-than-day')
                },
                {
                    value: 'R-',
                    text: this.$t('entered-days-date-lesser-than-day')
                }, {
                    value: 'S',
                    text: this.$t('transfer-date-lesser-dayday')
                }, {
                    value: 'S+',
                    text: this.$t('number-date-lesser-than-day')
                }, {
                    value: 'S-',
                    text: this.$t('number-date-lesser-than-day')
                }, {
                    value: 'V',
                    text: this.$t('day-of-the-next-month')
                }, {
                    value: 'V+',
                    text: this.$t('next-month-number-entered-days')
                }, {
                    value: 'V-',
                    text: this.$t('next-month-number-entered-days-v2')
                }
            ],
            loadingvmodel: false,
            mukellefScroll: false,
            cokluposta: false,
            postaitems: [],
            valid: true,
            validabanka:true,
            defaultvalue: 0,
            efaturami: false,
            drawer: null,
            baslik: '',
            e1: 0,
            Code: '',
            e2: true,
            yok: false,
            statecari: [],
            search: '',
            search1: '',
            loading: false,
            Current: {
                Buyer_Seller:0,
                AvailableCompany:0,
                Explanations: null,
                PrivateCode5:null,
                PrivateCode6:null,
                PrivateCode7:null,
                PrivateCode8:null,
                PeriodControl:false,
                CompanyCode: '',
                Code: null,
                Title: null,
                Title2: null,
                Phone1: '',
                Phone2: '',
                Mobile: '',
                Web: '',
                Email: '',
                AccountGroup: '',
                AccountingCode: null,
                Type: '',
                CMCode: '',
                Reserved1: '',
                Reserved2: '',
                Authorized: '',
                WarningNote: '',
                InfoNote: '',
                CustomerType: '',
                TicketBill: '',
                EInvoiceType: '0',
                PostCodeLabel: '',
                EInvoiceCustomer: '',
                MultiPostUse: '',
                InActive: '',
                InActiveDate: '',
                EArchiveSendType: false,
                EArchiveSendPaper: false,
                CreditLimit: 0,
                CreditLimitCurrencyAmount: '',
                CreditLimitCurrency: '',
                WebPassword: '',
                PinCode: '',
                MileCode: '',
                Bank:'',
                ExpiryDayDomestic: '',
                ExpiryTypeDomestic: '',
                ExpiryDayInt: '',
                ExpiryTypeInt: '',
                ExpiryDayGeneral: '',
                ExpiryTypeGeneral: '',
                DiscountGeneral: '',
                DiscountDom: '',
                DiscountInt: '',
                DiscountDomService: '',
                DiscountIntService: '',
                TaxFree: '',
                ExternalCurrentCode: '',
                ExternalAccountingCode: '',
                StreamCurrentCode: '',
                ArkmanStreamCode: '',
                ArkmanStreamPassword: null,
                ExpenseCenter: '',
                TemplateID: '',
                ProfileForced: '',
                EventIDForced: '',
                MainAccount: '',
                AnalysisCode:'',
                CustomReportTemplate:[],
                BankInfo:[],
                Invoice: {
                    SpendingUnitVKN:'',
                    Address: '',
                    PostCode: '',
                    Province: '',
                    Country: '',
                    TaxNumber: '',
                    TaxOffice: '',
                    IdentityNumber: '',
                    PerFirstName: '',
                    PerFamilyName: '',
                    PerTitle: '',
                    PerMiddleName: '',
                    PerNameSuffix: '',
                    NoPrint: '',
                    CustomerPersonelNoInvoice: '',
                    DeliveryAddress: '',
                    DeliveryName: '',
                    BuildingNumber:''
                },
                Contract: {
                    ContractNumber: '',
                    ContractDate: '',
                    PaymentType: '',
                    BankAccountNumber: '',
                    BankBranchOffice: '',
                    InvoiceRowNumber: '',
                    InvoicePassengerName: '',
                    InvoiceFlightNumber: '',
                    IadeCariAyrilsin: false,
                    IadeCariKod: ''
                }
            },

            ServisParametreYedek: {
                ServisKod11: 11,
                Doviztip11: null,
                Fiyat11: 0,

                ServisKod12: 12,
                Doviztip12: null,
                Fiyat12: 0,

                ServisKod13: 13,
                Doviztip13: null,
                Fiyat13: 0,

                ServisKod15: 15,
                Doviztip15: null,
                Fiyat15: 0,

                ServisKod19: 19,
                Doviztip19: null,
                Fiyat19: 0,

                ServisKod21: 21,
                Doviztip21: null,
                Fiyat21: 0,

                ServisKod22: 22,
                Doviztip22: null,
                Fiyat22: 0,

                ServisKod31: 31,
                Doviztip31: null,
                Fiyat31: 0,

                ServisKod32: 32,
                Doviztip32: null,
                Fiyat32: 0,

                ServisKod33: 33,
                Doviztip33: null,
                Fiyat33: 0,

                ServisKod40: 40,
                Doviztip40: null,
                Fiyat40: 0,

                ServisKod44: 44,
                Doviztip44: null,
                Fiyat44: 0,

            },

            ServisParametre: {
                ServisKod11: 11,
                Doviztip11: null,
                Fiyat11: 0,
                DefaultServis11: false,

                ServisKod12: 12,
                Doviztip12: null,
                Fiyat12: 0,
                DefaultServis12: false,

                ServisKod13: 13,
                Doviztip13: null,
                Fiyat13: 0,
                DefaultServis13: false,

                ServisKod15: 15,
                Doviztip15: null,
                Fiyat15: 0,
                DefaultServis15: false,

                ServisKod19: 19,
                Doviztip19: null,
                Fiyat19: 0,
                DefaultServis19: false,
                ServisKod21: 21,

                Doviztip21: null,
                Fiyat21: 0,
                DefaultServis21: false,

                ServisKod22: 22,
                Doviztip22: null,
                Fiyat22: 0,
                DefaultServis22: false,

                ServisKod31: 31,
                Doviztip31: null,
                Fiyat31: 0,
                DefaultServis31: false,

                ServisKod32: 32,
                Doviztip32: null,
                Fiyat32: 0,
                DefaultServis32: false,

                ServisKod33: 33,
                Doviztip33: null,
                Fiyat33: 0,
                DefaultServis33: false,

                ServisKod40: 40,
                Doviztip40: null,
                Fiyat40: 0,
                DefaultServis40: false,

                ServisKod44: 44,
                Doviztip44: null,
                Fiyat44: 0,
                DefaultServis44: false,
            },
caritipi: [{
                    text: this.$t('Customer-and-Supplier'),
                    value: 0
                },
                {
                    text: this.$t('Supplier'),
                    value: 1
                }, {
                    text: this.$t('Customer'),
                    value: 2
                },
            ],
            musteritipi: [{
                    text: this.$t('Individual'),
                    value: 'B'
                },
                {
                    text: this.$t('Corporate'),
                    value: 'K'
                }, {
                    text: this.$t('Public'),
                    value: 'Ka'
                },
            ],
            efaturatipi: [{
                    text: this.$t('Commercial'),
                    value: '0'
                },
                {
                    text: this.$t('Basic'),
                    value: '1'
                },
                {
                    text: this.$t('Export'),
                    value: '2'
                },
                {
                    text: this.$t('Public'),
                    value: '3'
                }
            ],
            islembilgileri: [{
                    text: this.$t('Hard-Copy-Invoice'),
                    value: 'false'
                },
                {
                    text: this.$t('Electronic-Invoice'),
                    value: 'true'
                }
            ],
            itemsSablon:[],
            itemsSablonSelected:[],
            doviztipi: [],
            ichattipi: [
                'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
            ],
            evethayir: [{
                    text: this.$t('Yes'),
                    value: 'E'
                },
                {
                    text: this.$t('No-v2'),
                    value: 'H'
                },
            ],
            cmkodu: [
                'C', 'M'
            ],
            masrafmerkezi: [],
            dictionary: {
                custom: {
                    carikod: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },
                    unvan: {
                        required: () => this.$t('This-space-cannot-left-blank'),
                    },

                }
            },
            disyuzde: false,
            icyuzde: false,
            StartDate: null,
            EndDate: null,
            NumberOfPolicies: '',
            PolicySum: '',
            TotalDebt: '',
            TotalFlatDebt: '',
            guncellebuton: false,
            silbuton: false,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',
            text1: '',
            ichatdoviztipi1: false,
            ichatdoviztipi2: false,
            ichatdoviztipi3: false,
            ichatdoviztipi4: false,
            ichatdoviztipi5: false,
            dishatdoviztipi1: false,
            dishatdoviztipi2: false,
            dishatdoviztipi3: false,
            dishatdoviztipi4: false,
            dishatdoviztipi5: false,
            dishatdoviztipi6: false,
            dishatdoviztipi7: false,
            biletlerfaturalanmasin: null,
            efaturamukellefi: false,
            Kdvmuaf: null,
            ciktiistemiyor: null,
            musteribilgitipi: null,
            profilzorunlu: null,
            eventidzorunlu: null,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            carikod: '',
            unvan: '',
            active: '',
            ex11: 'false',
            tabcontrol3: 0,
            icYuzdedenHesapla: {
                Yuzdeden: false,
                HesapTipi: null,
                HesapYuzde: 0
            },
            DisYuzdedenHesapla: {
                Yuzdeden: false,
                HesapTipi: null,
                HesapYuzde: 0
            },
            hesaptipi: [{
                    text: this.$t('Ticket-Amount'),
                    value: 0
                },
                {
                    text:  this.$t('Ticket-Amount') + '+' + this.$t('Taxes'),
                    value: 1
                }
            ]
        }
    },
    created() {
    this.Current = this.Current || {};
    this.Current.Contract = this.Current.Contract || {};
    if (this.Current.Contract.Tevkifatli === undefined)
      this.$set(this.Current.Contract, "Tevkifatli", false);
    if (this.Current.Contract.TevkifatOrani === undefined)
      this.$set(this.Current.Contract, "TevkifatOrani", null);
      if (this.Current.Contract.TevkifatKodu === undefined)
      this.$set(this.Current.Contract, "TevkifatKodu", "");

   if (this.Current.Contract.IadeCariAyrilsin === undefined)
  this.$set(this.Current.Contract, "IadeCariAyrilsin", false);

if (this.Current.Contract.IadeCariKod === undefined)
  this.$set(this.Current.Contract, "IadeCariKod", "");
   
  },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    mounted() {
        this.$validator.localize('en', this.dictionary)

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.PB=credentials.ParaBirimi;
            this.accounting=JSON.parse(window.localStorage.getItem('nextMuhasebe'));

tool.http_post(this, "UlkeList", {}).then(
    (response) => {
      if (response.body.Status == true) {
        response.body.data.forEach((element) => {
           this.ulkeTipi.push(element.Isim);
          });
      } else {
        this.text1 = "Service Unavailable-country";
        this.snackbar = true;
      }
    },
    (response) => {
      this.text1 = "Service Unavailable";
      this.snackbar = true;
    }
  );

            var params = {

                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/Definitions/CurrentGroupList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.hesapgurubu = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/currency/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.doviztipi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Döviz Tipi'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Döviz Tipi'
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.masrafmerkezi = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Masraf Merkezi'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-Masraf Merkezi'
                    this.snackbar = true
                }
            })

            var CurrentInput = {
                Code: this.$route.params.id,
                CompanyCode: credentials.SirketKodu
            }
            this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                this.Current = response.body
                this.Current.EInvoiceType = String(response.body.EInvoiceType)
                this.Current.EInvoiceCustomer = String(response.body.EInvoiceCustomer)
                this.Current.EArchiveSendType = String(response.body.EArchiveSendType)
                this.Current.ProfileForced = String(response.body.ProfileForced)
                this.Current.EventIDForced = String(response.body.EventIDForced)

                if (response.body.CreditLimit == "" || response.body.CreditLimit == null) {
                    this.Current.CreditLimit = 0
                } else {
                    this.Current.CreditLimit = parseFloat(response.body.CreditLimit)
                }
                this.Current.MainAccount = response.body.MainAccount

                this.date = response.body.Contract.ContractDate

                if (response.body.TicketBill == '1') {
                    this.biletlerfaturalanmasin = true
                } else {
                    this.biletlerfaturalanmasin = false
                }

                if (response.body.EInvoiceCustomer == '1') {

                    this.efaturamukellefi = true
                } else {
                    this.efaturamukellefi = false
                }

                if (response.body.Invoice.NoPrint == '1') {

                    this.ciktiistemiyor = true
                } else {
                    this.ciktiistemiyor = false
                }

                if (response.body.TaxFree == '1') {
                    this.Kdvmuaf = true
                } else {
                    this.Kdvmuaf = false
                }

                if (response.body.ProfileForced == '1') {

                    this.profilzorunlu = true
                } else {
                    this.profilzorunlu = false
                }

                if (response.body.EventIDForced == '1') {

                    this.eventidzorunlu = true
                } else {
                    this.eventidzorunlu = false
                }

                if (response.body.Invoice.CustomerPersonelNoInvoice == '1') {

                    this.musteribilgitipi = true
                } else {
                    this.musteribilgitipi = false
                }

                var prm = {
                    SirketKodu: credentials.SirketKodu,
                    CariKodu: response.body.Code
                }

                this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamList', prm, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.aktarimitems = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = response.body.StatusText
                    this.snackbar = true
                }
            })

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        var url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        var url = '#/'
                        window.open(url, '_self')
                    }
                // eslint-disable-next-line no-empty
                } else {

                }

            });

        }

    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
    },
    methods: {
        IBANGuncelle()
        {
            this.IBANDialog=false;
        },
        IBANGuncelleAc(item)
        {
            this.guncelleIBAN=item;
            this.IBANDialog=true;
         
        },
        IBANEkle()
        {
            if (this.$refs.formbanka.validate())
        {
            var bankinfoekle={
            IBAN:this.IBANAd,
            Description:this.IBANDesc,
            Silinecek:false
          }
          this.Current.BankInfo.push(bankinfoekle);
        }
        
        },
        ItemAktar(value,key){
            switch (key) {
                case 1:
                    var indexAdd = this.itemsSablon.indexOf(value);
                    this.itemsSablon.splice(indexAdd,1);
                    this.itemsSablonSelected.push(value);
                    break;
                case 2:
                    var indexDelete = this.itemsSablonSelected.indexOf(value);
                    this.itemsSablonSelected.splice(indexDelete,1);
                    this.itemsSablon.push(value);
                    break;
            
                default:
                    break;
            }
        },
        sablonGetir() {
            if(this.itemsSablonSelected.length <= 0 && this.itemsSablon.length <= 0){
            
            tool.api_post(this, "RaporSablon/GetReportBroDesignGrupAll", {
                id: 0,
                ad: 'GenelAmacli',
                objectName: 'Models.GenelAmacliClass'
            })
            .then(
                response => {
                     this.itemsSablon = response.body;
                    // this.current.CustomReportTemplate

                    this.Current.CustomReportTemplate.forEach(element => {
                        
                        const index = this.itemsSablon.findIndex(item => item.id == element.TemplateId);
                        if(index != -1){
                        this.itemsSablonSelected.push(this.itemsSablon[index]);
                        this.itemsSablon.splice(index,1);
                        }
                 

                    });
                        
                
           

               
                },
                (response) => {
                    this.text1 = 'Sablon getirilemedi, tekrar deneyiniz.'
                    this.snackbar = true

                }
            );
            }
        },
        ActiveCurrent(){
             var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var params = {}
            if (this.Current.InActive == true) {
                params = {
                    SirketKodu: credentials.SirketKodu,
                    HesapKodu: this.Current.Code,
                    KapatAc: true
                }
                this.Current.InActiveDate = getDateNow()
            } else {
                params = {
                    SirketKodu: credentials.SirketKodu,
                    HesapKodu: this.Current.Code,
                    KapatAc: false
                }
            }
            this.$http.post(auth.API_URL + 'api/Current/CurrentHideShow', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                //Kapatılan Tarihi burada göster
                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true

                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true

                }
            })
        },
        getparabirimi() {
            return helpers.getparabirimi()
        },
        karsidegeral(val) {
            if (val == true) {
                return false
            } else if (val == false) {
                return false
            }
        },
        HataYonetimi(response, request, baslik) {
            this.mukellefScroll = false
            if (response.status === 500) {
                //Internal Server Error
                this.$refs.hatadialog.open(response, request, baslik);
            } else {
                this.text1 = "Service Unavailable -" + baslik;
                this.snackbar = true;
            }
        },

        DefaultIcAyarlar(a, b) {
            var nerden = b
            if (this.ServisParametre.DefaultServis11 == true && nerden != '11') {
                this.ServisParametre.DefaultServis11 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis12 === true && nerden != '12') {
                this.ServisParametre.DefaultServis12 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis13 === true && nerden != '13') {
                this.ServisParametre.DefaultServis13 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis15 === true && nerden != '15') {
                this.ServisParametre.DefaultServis15 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis19 === true && nerden != '19') {
                this.ServisParametre.DefaultServis19 = this.karsidegeral(a)
            }
        },
        DefaultDisAyarlar(a, b) {
            var nerden = b
            if (this.ServisParametre.DefaultServis21 == true && nerden != '21') {
                this.ServisParametre.DefaultServis21 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis22 === true && nerden != '22') {
                this.ServisParametre.DefaultServis22 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis31 === true && nerden != '31') {
                this.ServisParametre.DefaultServis31 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis32 === true && nerden != '32') {
                this.ServisParametre.DefaultServis32 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis33 === true && nerden != '33') {
                this.ServisParametre.DefaultServis33 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis40 === true && nerden != '40') {
                this.ServisParametre.DefaultServis40 = this.karsidegeral(a)
            }
            if (this.ServisParametre.DefaultServis44 === true && nerden != '44') {
                this.ServisParametre.DefaultServis44 = this.karsidegeral(a)
            }

        },

        islemiptal() {
            this.guncellbtn = false
            this.havayolukodu = null
            this.aktarimKodu = null
            this.havayoluLabel = this.$t('Transfer-Code-v2')
        },
        satirsil() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var prm = {
                ID: this.silinecekkayit.ID,
            }

            this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamDelete', prm, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true

                if (response.body.Status == true) {
                    this.dialogsor = false
                }

                var prm = {
                    SirketKodu: credentials.SirketKodu,
                    CariKodu: this.Current.Code
                }

                this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamList', prm, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.aktarimitems = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        },
        aktarimGuncelle() {

            if (this.$refs.formtarih.validate()) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var prm = {
                    SirketKodu: credentials.SirketKodu,
                    CariKodu: this.Current.Code,
                    HavayoluKodu: this.havayolukodu,
                    AktarimKodu: this.aktarimKodu,
                    ID: this.silinecekkayit.ID
                }

                this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamSave', prm, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    // this.aktarimitems = response.body

                    if (response.body.Status == true) {
                        this.islemiptal();
                    }

                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true

                    var prm = {
                        SirketKodu: credentials.SirketKodu,
                        CariKodu: this.Current.Code
                    }

                    this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamList', prm, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.aktarimitems = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

            }
        },
        satirduzenle(item) {

            this.guncellbtn = true,
                this.havayolukodu = item.HavayoluKodu
            this.aktarimKodu = item.AktarimKodu
            this.silinecekkayit = item
        },

        satirsilsor(item) {
            this.dialogsor = true;
            this.satirsilbtn = true,
                this.silinecekkayit = item
        },
        IBANSilSor(item) {
            this.dialogsorIBAN = true;
            this.silinecekIBAN=item;
        },
        IBANSil() {
            this.silinecekIBAN.Silinecek=true;
            this.dialogsorIBAN = false;
            
        },
        aktarimkoduEkle() {

            if (this.$refs.formtarih.validate()) {

                var durum = true

                if (this.aktarimitems.length == 0) {
                    durum = true
                } else {
                    this.aktarimitems.forEach(element => {
                        if (element.HavayoluKodu == this.havayolukodu) {
                            durum = false
                        }
                    });
                }

                if (durum != false) {

                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                    var prm = {
                        SirketKodu: credentials.SirketKodu,
                        CariKodu: this.Current.Code,
                        HavayoluKodu: this.havayolukodu,
                        AktarimKodu: this.aktarimKodu
                    }

                    this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamSave', prm, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                        // this.aktarimitems = response.body

                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true

                        var prm = {
                            SirketKodu: credentials.SirketKodu,
                            CariKodu: this.Current.Code
                        }

                        this.$http.post(auth.API_URL + 'api/Current/CurrentAirlineStreamList', prm, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {
                            this.aktarimitems = response.body
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable'
                                this.snackbar = true
                            } else {
                                this.text1 = 'Service Unavailable'
                                this.snackbar = true
                            }
                        })
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })
                } else {
                    this.text1 = this.$t('Airline-wish-add-included-records')
                    this.snackbar = true
                }
            }
        },
        mukellefSorgula() {

            if (this.Current.Invoice.TaxNumber.length == 10) {
                this.mukellefScroll = true

                let prm = {
                    VKN: this.Current.Invoice.TaxNumber //9240492097
                }

                tool.api_post(this, "EFatura/VKN_Sorgula", prm).then(

                    response => {
                        this.mukellefScroll = false

                        this.postaitems = []

                        if (response.body.length > 0) {
                            this.efaturamukellefi = true

                            if (response.body.length > 1) {

                                this.cokluposta = true
                                response.body.forEach(element => {
                                    this.postaitems.push(element.alias)
                                });
                                this.Current.PostCodeLabel = response.body[0].alias
                            } else {
                                this.cokluposta = false
                                this.Current.PostCodeLabel = response.body[0].alias

                            }

                        } else {
                            this.text1 = this.$t('No-liable-found')
                            this.snackbar = true
                        }

                    },
                    response => {
                        this.HataYonetimi(response, prm, 'Mükellef Sorgulanamadı');

                    }
                );

            }else if(this.Current.Invoice.IdentityNumber.length == 11){

                let prm = {
                    VKN: this.Current.Invoice.IdentityNumber //9240492097
                }

                tool.api_post(this, "EFatura/VKN_Sorgula", prm).then(
                    response => {
                        this.mukellefScroll = false

                        this.postaitems = []

                        if (response.body.length > 0) {
                            this.efaturamukellefi = true

                            if (response.body.length > 1) {

                                this.cokluposta = true
                                response.body.forEach(element => {
                                    this.postaitems.push(element.alias)
                                });
                                this.Current.PostCodeLabel = response.body[0].alias
                            } else {
                                this.cokluposta = false
                                this.Current.PostCodeLabel = response.body[0].alias
                            }
                        } else {
                            this.text1 = this.$t('No-liable-found')
                            this.snackbar = true
                        }
                    },
                    response => {
                        this.HataYonetimi(response, prm, 'Mükellef Sorgulanamadı');

                    }
                );
            } else {
                this.text1 = this.$t('enter-number-digit-Identity-Number')
                this.snackbar = true
            }

        },
        guncelle: guncelle,
        ekle: ekle,
        carisil: carisil,
        karsidegeral: karsidegeral,
        serviskaydet: serviskaydet,
        servissil: servissil,
        getDateNow:getDateNow
    },
    beforeMount: beforeMount,
    components: {
        'parainput': parainput,
        yuzdeinput,
        tarihim,
        yetkidialog,
        hatadialog,
        cariaracomp,
        analizcomp,
        muhasebekoducomp,
        snackbarcomp,
        loadingcomp
    },

    watch: {
    "Current.Contract.Tevkifatli"(val) {
  if (!val) {
    this.Current.Contract.TevkifatOrani = null;
    this.Current.Contract.TevkifatKodu = "";
  }
},
"Current.Contract.IadeCariAyrilsin"(val) {
    if (!val) this.Current.Contract.IadeCariKod = "";
  },
        'havayolukodu': function (value) {
            if (value != null) {
                this.itemsairlinelist.forEach(element => {
                    if (element.HavaYoluKodu == value) {
                        this.havayoluLabel = element.Title.toLocaleLowerCase('tr') + " " + this.$t('Transfer-Code-v2')
                    }
                });

            // eslint-disable-next-line no-empty
            } else {

            }
        },
        'icYuzdedenHesapla.Yuzdeden': function (value) {
            if (value == true) {
                this.icyuzde = true
                this.icYuzdedenHesapla.HesapTipi = 0
            } else {
                this.icyuzde = false
                this.icYuzdedenHesapla.HesapTipi = null
            }
        },
        'DisYuzdedenHesapla.Yuzdeden': function (value) {
            if (value == true) {
                this.disyuzde = true
                this.DisYuzdedenHesapla.HesapTipi = 0
            } else {
                this.disyuzde = false
                this.DisYuzdedenHesapla.HesapTipi = null
            }
        },
        'efaturamukellefi': function (value1) {

            if (value1 === true) {
                this.efaturami = true

            } else {
                this.efaturami = false
                this.Current.EInvoiceType = null
                this.Current.PostCodeLabel = null
                this.Current.MultiPostUse = false
            }
        },
        active(val1) {
            //tablar aktif olunca değerleri çekelim

            if (val1 == 3 && this.tabcontrol3 != 1) {

                this.tabcontrol3 = 1

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params = {
                    CompanyCode: credentials.SirketKodu,
                    AccountCode: this.Current.Code
                }

                this.$http.post(auth.API_URL + 'api/Current/CurrentServiceGet', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    response.body.forEach(element => {

                        if (element.ServisKod == '11') {
                            this.ServisParametre.Fiyat11 = element.Fiyat;
                            this.ServisParametre.Doviztip11 = element.DovizTip;
                            this.ServisParametre.DefaultServis11 = element.DefaultServis;
                            this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '12') {

                            this.ServisParametre.Fiyat12 = element.Fiyat;
                            this.ServisParametre.Doviztip12 = element.DovizTip;
                            this.ServisParametre.DefaultServis12 = element.DefaultServis;

                            this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '13') {

                            this.ServisParametre.Fiyat13 = element.Fiyat;
                            this.ServisParametre.Doviztip13 = element.DovizTip;
                            this.ServisParametre.DefaultServis13 = element.DefaultServis;

                            this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '15') {
                            this.ServisParametre.Fiyat15 = element.Fiyat;
                            this.ServisParametre.Doviztip15 = element.DovizTip;
                            this.ServisParametre.DefaultServis15 = element.DefaultServis;

                            this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '19') {
                            this.ServisParametre.Fiyat19 = element.Fiyat;
                            this.ServisParametre.Doviztip19 = element.DovizTip;
                            this.ServisParametre.DefaultServis19 = element.DefaultServis;

                            this.icYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.icYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.icYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '21') {
                            this.ServisParametre.Fiyat21 = element.Fiyat;
                            this.ServisParametre.Doviztip21 = element.DovizTip;
                            this.ServisParametre.DefaultServis21 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '22') {
                            this.ServisParametre.Fiyat22 = element.Fiyat;
                            this.ServisParametre.Doviztip22 = element.DovizTip;
                            this.ServisParametre.DefaultServis22 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '31') {
                            this.ServisParametre.Fiyat31 = element.Fiyat;
                            this.ServisParametre.Doviztip31 = element.DovizTip;
                            this.ServisParametre.DefaultServis31 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '32') {
                            this.ServisParametre.Fiyat32 = element.Fiyat;
                            this.ServisParametre.Doviztip32 = element.DovizTip;
                            this.ServisParametre.DefaultServis32 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '33') {
                            this.ServisParametre.Fiyat33 = element.Fiyat;
                            this.ServisParametre.Doviztip33 = element.DovizTip;
                            this.ServisParametre.DefaultServis33 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '40') {
                            this.ServisParametre.Fiyat40 = element.Fiyat;
                            this.ServisParametre.Doviztip40 = element.DovizTip;
                            this.ServisParametre.DefaultServis40 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                        if (element.ServisKod == '44') {
                            this.ServisParametre.Fiyat44 = element.Fiyat;
                            this.ServisParametre.Doviztip44 = element.DovizTip;
                            this.ServisParametre.DefaultServis44 = element.DefaultServis;

                            this.DisYuzdedenHesapla.Yuzdeden = element.Yuzdeden;
                            this.DisYuzdedenHesapla.HesapTipi = element.HesapTipi;
                            this.DisYuzdedenHesapla.HesapYuzde = element.HesapYuzde
                        }

                    });

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
            }
        }
    }
}

function karsidegeral(val) {
    if (val == true) {
        return false
    } else if (val == false) {
        return false
    }
}

    function getDateNow() {
        var today = new Date();
        var dd = today.getDate();
        var mm = today.getMonth() + 1; //January is 0!
        var yyyy = today.getFullYear();

        if (dd < 10) {
            dd = '0' + dd
        }

        if (mm < 10) {
            mm = '0' + mm
        }
        today = yyyy + '-' + mm + '-' + dd
        return today
    }

function serviskaydet() {
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var yenidizi = [];

    var yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '11',
        Aciklama: 'İç Low Cost',
        Fiyat: this.ServisParametre.Fiyat11,
        DovizTip: this.ServisParametre.Doviztip11,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis11
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '12',
        Aciklama: 'İç Eco Cost',
        Fiyat: this.ServisParametre.Fiyat12,
        DovizTip: this.ServisParametre.Doviztip12,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis12
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '13',
        Aciklama: 'İç Business',
        Fiyat: this.ServisParametre.Fiyat13,
        DovizTip: this.ServisParametre.Doviztip13,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis13
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '15',
        Aciklama: 'İç İade',
        Fiyat: this.ServisParametre.Fiyat15,
        DovizTip: this.ServisParametre.Doviztip15,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis15
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '19',
        Aciklama: 'İç Rezervasyon Değişimi',
        Fiyat: this.ServisParametre.Fiyat19,
        DovizTip: this.ServisParametre.Doviztip19,
        Yuzdeden: this.icYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.icYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.icYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis19
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '21',
        Aciklama: 'Dış Short Cost',
        Fiyat: this.ServisParametre.Fiyat21,
        DovizTip: this.ServisParametre.Doviztip21,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis21
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '22',
        Aciklama: 'Dış Short Business',
        Fiyat: this.ServisParametre.Fiyat22,
        DovizTip: this.ServisParametre.Doviztip22,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis22
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '31',
        Aciklama: 'Dış Long Eco',
        Fiyat: this.ServisParametre.Fiyat31,
        DovizTip: this.ServisParametre.Doviztip31,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis31
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '32',
        Aciklama: 'Dış Long Business',
        Fiyat: this.ServisParametre.Fiyat32,
        DovizTip: this.ServisParametre.Doviztip32,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis32
    }
    yenidizi.push(yenikayit);
    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '33',
        Aciklama: 'First Class',
        Fiyat: this.ServisParametre.Fiyat33,
        DovizTip: this.ServisParametre.Doviztip33,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis33
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '40',
        Aciklama: 'Dış İade',
        Fiyat: this.ServisParametre.Fiyat40,
        DovizTip: this.ServisParametre.Doviztip40,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis40
    }
    yenidizi.push(yenikayit);

    yenikayit = {
        SirketKodu: credentials.SirketKodu,
        CariKodu: this.Current.Code,
        ServisKod: '44',
        Aciklama: 'Dış Rezervasyon Değişimi',
        Fiyat: this.ServisParametre.Fiyat44,
        DovizTip: this.ServisParametre.Doviztip44,
        Yuzdeden: this.DisYuzdedenHesapla.Yuzdeden,
        HesapTipi: this.DisYuzdedenHesapla.HesapTipi,
        HesapYuzde: this.DisYuzdedenHesapla.HesapYuzde,
        DefaultServis: this.ServisParametre.DefaultServis44
    }
    yenidizi.push(yenikayit);

    var params = yenidizi;

    this.$http.post(auth.API_URL + 'api/Current/CurrentServiceSave', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        }
    })

}

function servissil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu,
        AccountCode: this.Current.Code

    }

    this.$http.post(auth.API_URL + 'api/Current/CurrentServiceDelete', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        this.ServisParametre = this.ServisParametreYedek
        this.icYuzdedenHesapla.Yuzdeden = false
        this.icYuzdedenHesapla.HesapTipi = null
        this.icYuzdedenHesapla.HesapYuzde = 0
        this.DisYuzdedenHesapla.Yuzdeden = false
        this.DisYuzdedenHesapla.HesapTipi = null
        this.DisYuzdedenHesapla.HesapYuzde = 0

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        }
    })
}

function carisil() {

    // burda soralım istiyormusunuz diye

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu,
        AccountCode: this.Current.Code

    }

    this.$http.post(auth.API_URL + 'api/Current/Delete', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        if (response.body.Status == true) {
            this.text1 = 'Kayıt Silindi'
            this.snackbar = true
            setTimeout(function () {
                var url1 = '#/cari/index'
                window.open(url1, '_self')
            }.bind(this), 3000)
        } else {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
        }

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true

        }
    })
}



function beforeMount() {

    this.baslik = 'Cari Hesap Güncelle'

}

function ekle() {

    this.Current.Contract.ContractDate = this.date

    var current = this.Current
    this.$http.post(auth.API_URL + 'api/Current/New', current, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        if (response.body.Status === true) {
            this.text1 = 'Kayıt Eklendi'
            this.snackbar = true
        } else if (response.body.Status === false) {
            this.text1 = this.$t('Error')
            this.snackbar = true
        }
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            let data ={
            response: response,
            request: current,
            api:'Current/New',
            type:2,
            message: response.body.ExceptionMessage
            };
            this.$refs.showMessage.open(data);
        }
    })
}

function guncelle() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    this.$validator.validateAll().then((result) => {
        if (result) {
            this.loadingvmodel = true;
            this.Current.CustomReportTemplate = [];

             var selectedItems = new Array();

            this.itemsSablonSelected.forEach(element => {
                var item = {
                    TemplateId : element.id,
                    TemplateName : element.ad
                };
                selectedItems.push(item);
            });

            this.Current.CustomReportTemplate = selectedItems;

            this.Current.Contract.ContractDate = this.date

            if(this.tumsirketler === true){
                this.Current.CompanyCode = 0
            }else{
                this.Current.CompanyCode = credentials.SirketKodu
            }

            this.Current.AvailableCompany =  credentials.SirketKodu;
           
            if (this.biletlerfaturalanmasin == true) {
                this.Current.TicketBill = '1'
            } else {
                this.Current.TicketBill = '0'
            }

            if (this.efaturamukellefi == true) {
                this.Current.EInvoiceCustomer = '1'
            } else {
                this.Current.EInvoiceCustomer = '0'
            }

            if (this.ciktiistemiyor == true) {
                this.Current.Invoice.NoPrint = '1'
            } else {
                this.Current.Invoice.NoPrint = '0'
            }

            this.Current.Contract.ContractDate = this.date

            if (this.Kdvmuaf == true) {
                this.Current.TaxFree = '1'
            } else {
                this.Current.TaxFree = '0'
            }

            if (this.profilzorunlu == true) {
                this.Current.ProfileForced = '1'
            } else {
                this.Current.ProfileForced = '0'
            }
            if (this.eventidzorunlu == true) {
                this.Current.EventIDForced = '1'
            } else {
                this.Current.EventIDForced = '0'
            }

            if (this.musteribilgitipi === true) {
                this.Current.Invoice.CustomerPersonelNoInvoice = '1'
            } else {
                this.Current.Invoice.CustomerPersonelNoInvoice = '0'
            }
             if (this.Current.Contract.TevkifatOrani == null) {
                //TEVKİFAT NULL KONTROLÜ 
    if (this.Current.Contract.Tevkifatli) {
  if (this.Current.Contract.TevkifatOrani === null || this.Current.Contract.TevkifatOrani === '') {
    this.text1 = "Tevkifat oranı zorunlu";
    this.snackbar = true;
    this.counter = 0; this.loadingvmodel = false;
    return;
  }
  if (!this.Current.Contract.TevkifatKodu || String(this.Current.Contract.TevkifatKodu).trim() === '') {
    this.text1 = "Tevkifat kodu zorunlu";
    this.snackbar = true;
    this.counter = 0; this.loadingvmodel = false;
    return;
  }
} else {
  this.Current.Contract.TevkifatOrani = null;
  this.Current.Contract.TevkifatKodu = "";
}
  }
  if (!this.Current.Contract.IadeCariAyrilsin) {
  this.Current.Contract.IadeCariKod = "";
}
if (this.Current.Contract.IadeCariAyrilsin === true) {
  //if (!this.Current.Contract.IadeCariKod || !this.Current.Contract.IadeCariKod.trim()) {
    //this.text1 = "İade cari zorunlu";
    //this.snackbar = true;
    //this.counter = 0;
    //this.loadingvmodel = false;
    //return;
  //}
}

            

            var current = this.Current
            this.$http.post(auth.API_URL + 'api/Current/Update', current, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                if (response.body.Status === true) {
                    this.text1 =this.$t('Record-Updated')
                    this.snackbar = true
                    this.loadingvmodel = false;
                } else if (response.body.Status === false) {
                      this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.loadingvmodel = false;
                }
            }, (response) => {
                if (response.status === 0) {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                    this.loadingvmodel = false;
                } else {
                    let data ={
                    response: response,
                    request: current,
                    api:'Current/Update',
                    type:2,
                    message: response.body.ExceptionMessage
                    };
                    this.$refs.showMessage.open(data);
                    this.loadingvmodel = false;
                }
            })
        }
    })
}
</script>

<style>
@import '../../../assets/css/custom.css';
</style>
